import React, { MouseEvent } from 'react';
import { updateTabularQueryValue } from '../actions/initialActions';

const TabularDataLink = (props: { linkTo: string, tabDataClass?: string }) => {

    const handleClick = (event: MouseEvent) => {
        event.preventDefault();
        updateTabularQueryValue(props.linkTo, true);
    }
    return <span onClick={handleClick} className={`code-link ${props.tabDataClass}`}>{props.linkTo}</span>
}

export default TabularDataLink;